import React, {useEffect, useState} from "react";
import {IhioWrittenPrescriptionItemType} from "../../../../../types/ihioPrescriptionFilling";
import {toast} from "react-hot-toast";
import NumberField from "../../../general/form/numberField";
import Tooltip from "../../../general/tooltip";
import Icon from "../../../general/icon";
import Alert from "../../../general/alert";
import { NumericFormat } from "react-number-format";


type PrescriptionItemsToFulfilRowItemProps = {
    item: IhioWrittenPrescriptionItemType
    handleRemoveItemFromFulfil: (UUID: string) => void;
    handleUpdateRowItem: (UUID: string, item: IhioWrittenPrescriptionItemType, itemCount: number) => Promise<number | undefined>;
}

const PrescriptionItemsToFulfilRowItem = ({
    item,
    handleRemoveItemFromFulfil,
    handleUpdateRowItem
}: PrescriptionItemsToFulfilRowItemProps) => {

    const [showEdit, setShowEdit] = useState(false);
    const [itemsToBeDelivered, setItemsToBeDelivered] = useState<number>();

    useEffect(() => {
        if(item?.itemsToBeDelivered) {
            setItemsToBeDelivered(item?.itemsToBeDelivered)
        }
    }, [item?.itemsToBeDelivered]);

    const handleChangeItemsToBeDelivered = async () => {
        if(itemsToBeDelivered  && itemsToBeDelivered < 0) {
            toast('تعداد انتخاب شده نمی‌تواند کمتر از صفر می‌باشد.')
            return;
        }
        if(itemsToBeDelivered && (itemsToBeDelivered > ((item?.itemCount || 0) - determineRemainingItems()) )) {
            toast( 'تعداد انتخاب شده نمی‌تواند بیشتر از تعداد ارائه می‌باشد.')
            return
        }
        const resultStatus = await handleUpdateRowItem(item?.UUID || '', item, itemsToBeDelivered || 0)
        if(resultStatus === 200) {
            setShowEdit(false)
        }
    }

    const determineRemainingItems = () => {
        return item?.deliveredItems?.reduce((sum, item) => {
            return sum + (item.itemCount || 0);
        }, 0) || 0;
    }

    return (
        <div className={`card shadow-none border rounded-4`}>
            <div className={'card-body'}>
                <div className={'d-flex align-items-center justify-content-between'}>
                    <div className={'d-flex align-items-center gap-3'}>
                        <div
                            className={`btn-sm btn-icon rounded-circle ${showEdit ? 'btn-light-danger' : 'btn-light-primary'}`}
                            // icon={showEdit ? CrossIcon : PencilIcon}
                            // iconClassName={'svg-icon svg-icon-1'}
                            onClick={() => setShowEdit(!showEdit)}
                        />
                        {showEdit && (
                            <div
                                className={'d-flex align-items-center gap-3'}
                            >
                                <NumericFormat
                                    value={String(itemsToBeDelivered) || String(item?.itemsToBeDelivered)}
                                    onChange={event => setItemsToBeDelivered(Number(event?.target?.value))}
                                    name={"itemsToBeDelivered"}
                                    className={'tw-w-[100px] form-control form-control-sm '}
                                    placeholder={"تعداد را وارد کنید"}
                                />
                                <div className={'btn btn-primary btn-sm rounded rounded-4'}
                                     onClick={handleChangeItemsToBeDelivered}
                                >
                                    تایید
                                </div>
                                <span className={'fs-7 text-gray-500 text-nowrap'}>
                                    (حداکثر تعداد قابل ارائه {((item?.itemCount || 0) - (determineRemainingItems()))} عدد می‌باشد)
                                </span>
                            </div>
                        )}
                        {!showEdit && (
                            <div>
                                {item?.itemsToBeDelivered || 0} عدد
                                <Tooltip alt={'ویرایش'}>
                            <span>
                                <div
                                    className={`btn btn-sm btn-primary rounded rounded-circle px-2 py-1 me-3`}
                                    onClick={() => setShowEdit(!showEdit)}
                                >
                                    <Icon name='pen-square'/>
                                </div>
                            </span>
                                </Tooltip>
                            </div>
                        )}
                    </div>
                    <bdi className={'d-flex align-items-center gap-3'}>
                        <Tooltip alt={'حذف خدمت'}>
                            <span>
                                <div
                                    className={`btn btn-sm btn-danger rounded rounded-circle px-2 py-1`}
                                    onClick={() => handleRemoveItemFromFulfil(item?.UUID || '')}
                                >
                                    <Icon name='trash'/>
                                </div>
                            </span>
                        </Tooltip>
                        <div
                            className={'badge badge-primary px-2 py-2'}
                            title={item?.irc || ''}
                        />
                        <bdi>
                            {item?.name}
                        </bdi>
                        {item?.message?.info && item?.message?.info?.map((message: string) => {
                            return (
                                <Tooltip alt={message}>
                                    <span className={'text-purple font-20'}>
                                        <Icon name={'info-circle'}/>
                                    </span>
                                </Tooltip>
                            )
                        })}
                        {item?.message?.warning && item?.message?.warning?.map((message: string) => {
                            return (
                                <Tooltip alt={message}>
                                    <span className={'text-yellow font-20'}>
                                        <Icon name={'info-circle'}/>
                                    </span>
                                </Tooltip>
                            )
                        })}
                    </bdi>
                </div>
                {item?.description && (
                    <div className={'d-flex align-items-center mb-3'}>
                        <span className={'text-gray-600 me-3'}>
                            توضیحات:
                        </span>
                        <span className={'text-gray-900'}>
                            {item?.description}
                        </span>
                    </div>
                )}
                {
                    item?.message?.error?.map((item: string) => {
                        return (
                            <div className='mt-3'>
                                <Alert
                                    className={'border-dashed border-warning border-2'}
                                    type={'warning'}
                                    icon={'user-cross'}
                                    text={item}
                                />
                            </div>
                        );
                    })
                }
            </div>
        </div>
    )
}


export default PrescriptionItemsToFulfilRowItem;